
<template>
  <div class="home">
    <!-- 轮播图 -->
    <article id="sowingMap" class="animate__animated animate__zoomIn animate__slow">
      <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="2000">
        <!-- 轮播（Carousel）指标 -->
        <ol class="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
        </ol>
        <!-- 轮播（Carousel）项目 -->
        <div class="carousel-inner">
          <div class="item active">
            <img src="../assets/images/banner2.jpg" alt="First slide">
          </div>
          <div class="item">
            <img src="../assets/images/banner3.jpg" alt="Second slide">
          </div>
          <div class="item">
            <img src="../assets/images/banner.jpg" alt="Third slide">
          </div>
        </div>
        <!-- 轮播（Carousel）导航 -->
        <a class="carousel-control left" href="#myCarousel" data-slide="prev"> <span _ngcontent-c3="" aria-hidden="true"
            class="glyphicon glyphicon-chevron-left"></span></a>
        <a class="carousel-control right" href="#myCarousel" data-slide="next"><span _ngcontent-c3="" aria-hidden="true"
            class="glyphicon glyphicon-chevron-right"></span></a>
      </div>
    </article>

    <!-- 视频展示 -->
    <article id="videoShow">
      <br>
      <br>

      <h2 class="title1 animate__animated animate__fadeIn animate__slower">视频展示</h2>

      <p class="enish">VIDEO</p>
      <div class="stule">
        <div class="squary">
        </div>
      </div>
      <br>
      <br>
      <div class="content-video">
        <div class="media animate__animated animate__fadeInLeft animate__slower" v-for="(item,index) in videoList"
          :key="index+'videoList'">
          <div class="media-left">
            <a href="#">
              <video autoplay controls v-bind:src="'http://www.yltd360.com/'+item.location">
              </video>
            </a>
          </div>
          <div class="media-body">
            <h5 class="media-heading">{{item.title}}</h5>
            <p class="texts2" v-html="item.describe"></p>
            <button class="look" id="look" @click="checkNav()">
              <router-link to="/home">查看更多</router-link>
            </button>
            <img class="jiantou" src="../assets/images/jiantou.png" alt="">
          </div>
        </div>
        <div class="row">
          <div class="video-left">
          </div>
          <div class="video-right video-backageimg">
          </div>
        </div>

      </div>

    </article>

    <div id="showC1">
      <!-- 产品展示 -->
      <article id="showC">
        <br>
        <br>
        <br>
        <h2 class="title2">产品展示</h2>

        <p class="enish">PRODUCT</p>
        <div class="stule">
          <div class="squary">
          </div>
        </div>
        <br>
        <br>
        <div class="show">
          <div class="col-md-4" v-for="(item,index) in productList" :key="index+'productList'"
            onClick="location.href=location.origin+'#/product'">
            <div class="con-show">
              <div class="imgs">
                <img v-bind:src="'http://www.yltd360.com/'+item.location" alt="">
              </div>
              <div>
                <h5>{{item.title}}</h5>
                <p class="texts" v-html="item.describe"></p>
              </div>
            </div>
          </div>

        </div>
        <footer class="title3">
          <button class="look" @click="checkNav()">
            <router-link to="/product">查看更多</router-link>
          </button>
          <img class="jiantou2" src="../assets/images/jiantou.png" alt="">
        </footer>
        <br />
        <br />
        <br />
      </article>
    </div>

    <!-- 为什么要选择我们 -->
    <article id="Choice">
      <img src="../assets/images/whychoose.jpg" alt="">

    </article>

    <!-- 新闻资讯 -->
    <article id="News">
      <div class="news">
        <br>
        <br>
        <h2 class="title4">新闻资讯</h2>
        <p class="enish">NEW</p>
        <div class="stule">
          <div class="squary">
          </div>
        </div>
        <br>
        <br>
        <div class="new-con">
          <div class="col-md-6" v-for="(item,index) in newList" :key="index+'newList'"
            onClick="location.href=location.origin+'#/news'">
            <div class="new-con-list">
              <div class="media">
                <div class="media-left">
                  <a href="#">
                    <!-- <img class="media-object" v-bind:src="item.img_url" alt=""> -->
                  </a>
                </div>
                <div class="media-body">
                  <h5 class="media-heading">{{item.title}}</h5>
                  <p class="texts" v-html="item.describe"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="title5">
          <button class="look" onClick="location.href=location.origin+'#/news'">查看更多</button>
          <img class="jiantou2" src="../assets/images/jiantou.png" alt="">
        </footer>
        <br />
        <br />
        <br />

      </div>

    </article>

  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      Index: document.location.hash,
      newList: [],
      productList: [], //产品
      videoList: [],
    };
  },

  created() {
    this.getNewList();
    this.getProductList();
    this.getVideo();
  },
  methods: {
    checkNav(index) {
      this.Index = document.location.hash;
    },
    getNewList() {
      let self = this;
      const req = {
        index: 1,
        size: 10,
      };
      this.$http
        .post("new/pageSelect/" + req.index + "/" + req.size, {})
        .then((data) => {
          if (data.body.success) {
            if (data.body.data.length <= 4) {
              for (var i in data.body.data) {
                self.newList.push(data.body.data[i]);
              }
            } else {
              for (var i = 0; i < 4; i++) {
                self.newList.push(data.body.data[i]);
              }
            }
          }
        });
    },
    getProductList() {
      let self = this;
      const req = {
        index: 1,
        size: 10,
      };
      this.$http
        .post("product/pageSelect/" + req.index + "/" + req.size, {})
        .then((data) => {
          if (data.body.success) {
            if (data.body.data.length <= 6) {
              for (var i in data.body.data) {
                self.productList.push(data.body.data[i]);
              }
            } else {
              for (var i = 0; i < 6; i++) {
                self.productList.push(data.body.data[i]);
              }
            }
          }
        });
    },
    getVideo() {
      const req = {
        index: 1,
        size: 10,
      };
      let self = this;
      this.$http
        .post("video/pageSelect/" + req.index + "/" + req.size, {})
        .then((data) => {
          if (data.body.success) {
            if (data.body.data.length <= 1) {
              for (var i in data.body.data) {
                self.videoList.push(data.body.data[i]);
              }
            } else {
              for (var i = 0; i < 1; i++) {
                self.videoList.push(data.body.data[i]);
              }
            }
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 500px) {
  #videoShow {
    width: 100% !important;
  }
  #videoShow .media {
    top: 53rem !important;
    width: 90% !important;
    height: 290px !important;
  }
  .media-body,
  .media-left,
  .media-right {
    display: table-cell;
    vertical-align: top;
  }
}

.ss {
  font-size: 50px;
}
.carousel-inner img {
  width: 100% !important;
  height: 100% !important;
}
.carousel-indicators {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  z-index: 15;
  width: 60%;
  padding-left: 0;
  margin-left: -30%;
  text-align: center;
  list-style: none;
}
.carousel-indicators li {
  background-color: #fff;
  width: 1rem;
  height: 1rem;
  margin: 0 1rem;
  transition: all 0.5s linear;
}

.carousel-indicators .active {
  height: 1rem;
  margin: 0 auto;
  width: 2rem;
  background-color: black;
}
.texts {
  position: relative;
  line-height: 1.4em;
  /* 3 times the line-height to show 3 lines */
  height: 4.2em;
  overflow: hidden;
}
.texts::after {
  content: "";
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 20px 1px 45px;
  background: url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png)
    repeat-y;
}
.texts2 {
  position: relative;
  line-height: 2.4em;
  height: 8.2em;
  overflow: hidden;
}
.texts2:hover {
  color: black !important;
  cursor: pointer;
}
.texts2::after {
  content: "";
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0 20px 1px 45px;
  background: url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png)
    repeat-y;
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}
h2 {
  font-size: 24px;
  color: #333333;
}
.home {
  clear: both;
  background: #ffffff;
}
.jiantou {
  width: 40px;
  height: 41px;
  position: absolute;
  bottom: 40.4px;
  right: 120px;
}
.jiantou2 {
  width: 40px;
  height: 41px;
  position: relative;
  left: -7px;
  top: -1.4px;
}
.enish {
  color: #e2e2e2;
}
/*标题下边的小横杆*/
.stule {
  width: 100%;
  height: 1px;
  display: block;
  margin: 0 auto;
  border: 0px none;
  background-color: #dadada;
}
.squary {
  /* width: 10px;
  height: 10px;
  background: #162887;
  position: relative;
  top: -4px;
  right: -31rem;
  border: 2px solid #ffffff;
  margin-left: 4px;
  margin-right: 4px; */
}

/* 轮播图 */
/*#sowingMap{
  margin:0 auto;
}*/
#sowingMap img {
  width: 100%;
  height: 545px;
  /*margin-top:1px;*/
}

/* 视频展示 */
#videoShow {
  margin: 0 auto;
  width: 60%;
  background: #ffffff;
}
#videoShow .row {
  width: 100%;
  display: flex;
}
.video-backageimg {
  width: 80%;
  height: 550px;
  background-image: url(../assets/images/backage-img.jpg);
  background-repeat: no-repeat;
  background-position: right;
  text-align: right;
}
.video-left {
  flex: 1;
}
.video-right {
  flex: 2;
}
#videoShow .media {
  position: absolute;
  top: 925px;
  background: #ffffff;
  width: 48%;
  height: 410px;
  padding: 10px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);
}
.content-video .media {
  display: flex;
}
.content-video .media .media-left {
  flex: 1.3;
}
.content-video .media .media-body {
  flex: 1;
}
.content-video .media-heading {
  margin-top: 40px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333333;
}

.content-video video {
  /*width: 100%;*/
  width: 520px;
}
.content-video .media-body p {
  margin-left: 61px;
  margin-right: 20px;
  margin-top: 10px;
  font-size: 12px;
  line-height: 24px;
  color: #9a9a9a;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

/* 产品展示 */
#showC1 {
  background: rgb(242, 243, 247);
}
#showC {
  width: 60%;
  margin: 0 auto;
  background: rgb(242, 243, 247);
}
.show .col-md-4 {
  margin-bottom: 30px;
}
.show .con-show {
  background: #ffffff;
  margin: 0px;
  padding-bottom: 8px;
  box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.show .con-show h5 {
  margin-top: 20px;
}
.show .con-show p {
  text-align: left;
  padding: 0 15px;
  font-size: 12px;
  color: #9a9a9a;
  line-height: 23px;
  margin-bottom: 20px;
}
.imgs {
  overflow: hidden;
  cursor: pointer;
}
.show img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.5s;
}
.show img:hover {
  transform: scale(1.2);
}
.look {
  width: 100px;
  height: 41px;
  line-height: 30px;
  font-size: 14px;

  background: #ffffff;
  border: 0px;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);
}
.look a {
  color: #999999 !important;
}
.look a:hover {
  color: black !important;
}
#look {
  position: absolute;
  bottom: 40px;
  right: 160px;
}

/*为什么要选我们*/
#Choice img {
  width: 100%;
}

/* 新闻资讯 */
#News {
  background: #ffffff;
  height: 80%;
  padding-bottom: 40px;
}
#News .news {
  width: 65%;
  margin: 0 auto;
}
#News .news .col-md-6 {
  padding: 10px;
}
#News .news .media {
  margin-bottom: 10px;
  background: #ffffff;
  padding: 20px;
  background: rgb(242, 243, 247);
}

#News .news .media .media-body p {
  text-align: left;
  font-size: 12px;
  color: #9a9a9a;
  margin-top: 10px;
  line-height: 24px;
}

#News .new-con .new-con-list {
  /*flex: 1;*/
  margin-left: 10px;
}

#News .new-con .media-body {
  padding-left: 15px;
  padding-top: 15px;
}

.content-video video {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
#videoShow .media {
  position: absolute;
  top: 855px;
  background: #ffffff;
  width: 53%;
  height: 334px;
  padding: 10px;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
}
.video-backageimg {
  width: 710px;
  height: 460px;
  background-image: url(../assets/images/backage-img.jpg);
  background-repeat: no-repeat;
  background-position: right;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue